import React, { useState } from 'react';
import { SearchBox } from 'tea-component';

export default function Search(props: any) {
  const {
    onChange,
    key,
    defaultValue,
    openBlurSearch = false,
    defaultParams: { placeholder = '', onSearch, onClear, ...restParams },
  } = props;

  const [searchValue, setSearchValue] = useState(defaultValue);
  return (
    <SearchBox
      className={`edit-search-box`}
      value={searchValue}
      onChange={(value) => {
        onChange?.(key, value);
        setSearchValue(value);
      }}
      placeholder={placeholder}
      onBlur={() => {
        if (openBlurSearch) {
          onSearch?.(searchValue);
        }
      }}
      {...restParams}
      onSearch={(value) => {
        onSearch?.(value);
      }}
      onClear={() => {
        setSearchValue('');
        onClear?.();
      }}
    />
  );
}
